<app-header></app-header>
<app-profile-header></app-profile-header>
<app-right-side></app-right-side>
<link
rel="stylesheet"
data-purpose="Layout StyleSheet"
title="Web Awesome"
href="/css/app-wa-86cd56275caec687041f80b17dc62e32.css?vsn=d"
>

<link
  rel="stylesheet"
  href="https://site-assets.fontawesome.com/releases/v5.15.4/css/all.css"
>
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.5.0/font/bootstrap-icons.css">
<div class="container" [dir]="direction" style="top:-100px; position: relative;">
    <div class="row">

        <!-- Main Content -->

        <div class="col col-xl-8 order-xl-2 col-lg-9 order-lg-1 col-md-12 col-sm-12 col-12">
            <div id="newsfeed-items-grid">
                <!-- /********************************** Post Form ******************************************************* -->
                <div class="ui-block"  style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                    <!-- News Feed Form  -->
                    <div class="news-feed-form">
                        <!-- Nav tabs -->
                        <ul class="nav nav-tabs" role="tablist" style="display: none;">
                            <li class="nav-item">
                                <a class="nav-link active inline-items" data-toggle="tab" href="#home-1" role="tab"
                                    aria-expanded="true">

                                    <svg class="olymp-status-icon">
                                        <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-status-icon">
                                        </use>
                                    </svg>

                                    <span>{{'profile.post' | translate}}</span>
                                </a>
                            </li>
                        </ul>
                        <!-- Tab panes -->
                        <div class="tab-content">
                            <div class="tab-pane active" id="home-1" role="tabpanel" aria-expanded="true">
                                <form [formGroup]="postForm" (ngSubmit)="setPost()">
                                    <div class="row">
                                        <div class="col-lg-2" style="margin: 0px auto;">
                                            <img *ngIf="!currentUser.success.user.avatar" src="assets/img/author-main1.webp"
                                            class="img-responsive img-fluid" alt="author" >
                                        <img *ngIf="currentUser.success.user.avatar" alt="author" [src]="userData[0].avatar"
                                            onerror="this.onerror=null; this.src='assets/img/author-main1.webp';"
                                            class="img-responsive img-fluid avatar img1" style=" width: 120px; height: 120px; padding: 10px;">
                                        </div>
                                        <div *ngIf="language !='ar'" class="col-lg-10" style="text-align: left; position: relative; right: 25px; top:18px;">
                                            <textarea class="form-control1" formControlName="content"
                                            placeholder="{{'profile.share_here' | translate}}" style="width: 100%; height: 40px; border-radius: 10px; border-color: #eceaea; background-color: var(--background-color); color: var(--text-color);"></textarea>
                                        </div>
                                        <div *ngIf="language =='ar'" class="col-lg-10" style="text-align: left; position: relative; right: -25px; top:18px;">
                                            <textarea class="form-control1" formControlName="content"
                                            placeholder="{{'profile.share_here' | translate}}" style="width: 100%; height: 40px; border-radius: 10px; border-color: #eceaea; background-color: var(--background-color); color: var(--text-color);"></textarea>
                                        </div>
                                    </div>
                                    <div class="add-options-message">
                                        <input style="display: none;" type="file" name="image" formControlName="image"
                                            #image (change)="onImageSelect($event)">
                                        <a href="javascript:void(0);" (click)="image.click()" class="options-message"
                                            data-toggle="tooltip" data-placement="top" data-original-title="Add File"  style="color:#3e758f">
                                            <i class="fas fa-image"></i>
                                            <Label style="margin: 0px 25px;"> {{imageName}}</Label>
                                        </a>
                                        <input style="display: none;" type="file" name="video" formControlName="video"
                                            #video (change)="onVideoSelect($event)">
                                        <a href="javascript:void(0);" (click)="video.click()" class="options-message"
                                            data-toggle="tooltip" data-placement="top" data-original-title="Add Video" style="color:#3e758f">
                                            <i class="fas fa-video"></i>
                                            <Label style="margin: 0px 25px;"> {{videoName}}</Label>
                                        </a>
                                        <button [disabled]="loading" class="btn btn-m1d-2 bt1n-info" style="background-color: #3e758f; color:#fff; border-radius: 5px; font-size: 15px;">
                                            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                                            <i class="fad fa-pen-square"></i>&nbsp;{{'profile.post' | translate}}
                                        </button>


                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>

                    <!-- ... end News Feed Form  -->
                </div>

                <!-- /*********************************************************************************************** -->
                <hr />
                <div *ngFor="let post of posts;trackBy: trackByFn" class="ui-block"  style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                    <article class="hentry post">
                        <div class="post__author author vcard inline-items">
                            <img *ngIf="!currentUser.success.user.avatar" src="assets/img/author-main1.webp"
                                class="img-responsive img-fluid" alt="author" >
                            <img *ngIf="currentUser.success.user.avatar" alt="author" [src]="userData[0].avatar"
                                onerror="this.onerror=null; this.src='assets/img/author-main1.webp';"
                                class="img-responsive img-fluid avatar" style=" width: 60px; height: 60px; padding: 2px;">

                            <div class="author-date">
                                <a class="h6 post__author-name fn"
                                    routerLink="/profile">{{ userData[0].fullName  | titlecase }}</a>
                                    <br>
                                    <time class="published" datetime="2017-03-24T18:18" style="font-size: 12px;">
                                        Last Update {{calculateDiff(post.created_at | date: 'yyyy-MM-dd')}}
                                    </time>
                            </div>
                            <div class="more">
                                <svg class="olymp-three-dots-icon">
                                    <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-three-dots-icon">
                                    </use>
                                </svg>
                                <ul class="more-dropdown">
                                    <li>
                                        <a (click)="openEditModal(postEditModal,post)">{{'profile.edit_post' | translate}}</a>
                                    </li>
                                    <li>
                                        <a (click)="openDeleteModal(postDeleteModal,post)">{{'profile.delete_post' | translate}}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <hr style="background-color: var(--text-color2);">
                        <p  style="font-size: 15px; font-family:Myriad Pro; background-color: var(--backgroundpost-color); color: var(--text-color);">
                            <Label [innerHTML]="urlify(post.content)" style="background-color: var(--backgroundpost-color); color: var(--text-color);"></Label>
                        </p>
                        <div class="post-thumb">
                            <img *ngIf="post.image" [src]="post.image" class="img-responsive img-fluid" alt="Image ">

                            <video *ngIf="post.video" id="my_video_1" class="video-js vjs-default-skin" width="100%"
                                height="auto" controls muted
                                data-setup='{ "aspectRatio":"640:267", "playbackRates": [1, 1.5, 2] }'>
                                <source [src]="post.video" type='video/mp4' />
                                <source [src]="post.video" type="video/webm">
                                {{'profile.embedded_video' | translate}}
                            </video>
                        </div>

                        <div>
                            <a (click)="likeUnlike(post.id)" id="post_id">
                                <i class="fad fa-thumbs-up" style="color: #e01b0d;"></i>&nbsp;
                                <span>{{post.likesCounter}}</span>
                            </a>
                            &nbsp; | &nbsp;
                            <a (click)="toggle(post.id)" style="text-align: left;">
                                <i class="fad fa-comments" style="color: #000000;"></i>&nbsp;
                                <span>{{post.commentsCounter}}</span>
                            </a>
                        </div>
                    </article>
                    <div class="modal-body">
                        <div class="mCustomScrollbar">
                            <ul *ngIf="show && show === post.id" [id]="post.id" class="comments-list">
                                <li *ngFor="let comment of comments;trackBy: trackByFn" class="comment-item"  style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                                    <div class="post__author author vcard inline-items">
                                        <img *ngIf="!comment.avatar" src="assets/img/author-main1.webp" width="50" height="50" alt="author" class="mCS_img_loaded">
                                        <img *ngIf="comment.avatar" alt="author" [src]="comment.avatar" class="img1">
                                    <div class="author-date">
                                        <a class="h5 post__author-name fn"> {{ comment.fullName | titlecase}} </a>
                                        <div class="post__date" style="font-size: 11px;"> {{calculateDiff(comment.commdate)}}</div>
                                        <div class="chat-message-item" style="padding: 5px; width: 100%; text-align: left; font-weight: normal; ">{{ comment.commentsContent}}</div>
                                    </div>
                                    <div class="more">
                                        <a (click)="openCommentDeleteModal(commentDeleteModal, comment , post.id)"><i class="fad fa-trash-alt" style="color:var(--text-color);"></i></a>
                                    </div></div>
                                </li>
                            </ul>
                        </div>
                        <form [formGroup]="commentForm" (ngSubmit)="doComment(post.id)" class="need-validation">
                            <div class="form-group">
                                <input class="form-control" placeholder="{{'profile.press_enter' | translate}}"
                                    formControlName="content" type="text" style="width: 100%; border-radius: 10px; border-color: #eceaea; background-color: var(--backgroundpost-color); color: var(--text-color);">
                            </div>
                            <button [disabled]="cloading" class="btn btn-m1d-1 btn-pri1mary" style="background-color: #3e758f; color:#fff; border-radius: 5px; font-size: 15px;">
                                <!-- <span *ngIf="cloading" class="spinner-border spinner-border-sm mr-1"></span> -->
                                <i class="fad fa-comment-dots"></i>&nbsp;{{'profile.comment' | translate}}
                            </button>
                        </form>
                    </div>
                    <!-- .. end Post -->
                </div>
            </div>
        </div>

        <!-- ... end Main Content -->


        <!-- Left Sidebar -->

        <div class="col col-xl-4 order-xl-1 col-lg-6 order-lg-2 col-md-6 col-sm-6 col-12" style="display: none;">
            <div class="crumina-sticky-sidebar">
                <div class="sidebar__inner">
                    <div class="ui-block">
                        <div class="ui-block-title"  style="background-color: #272626; color: #fff;">
                            <h6 class="title" style="color: #fff;"><i class="fad fa-address-card"></i>&nbsp;{{'profile.profile' | translate}}</h6>
                        </div>
                        <div class="ui-block-content">
                            <!-- W-Personal-Info -->
                            <ul class="widget w-personal-info item-block">
                                <li>
                                    <span class="title" style="color: #2c9c8a;">{{'profile.about_me' | translate}}</span>
                                    <span class="text" style="color: #3b3b3b; font-size: 12px;">{{'profile.hi' | translate}} {{userData[0].fullName  | titlecase}},<br>
                                        {{userData[0].about}}</span>
                                </li>
                                <li>
                                    <span class="title" style="color: #207dd3;">{{'profile.hobbies' | translate}}</span>
                                    <span class="text" style="color: #3b3b3b; font-size: 12px;">{{userData[0].hobby1}}</span>
                                </li>
                                <li>
                                    <span class="title" style="color: #9c3845;">{{'profile.fav_games' | translate}}</span>
                                    <span class="text" style="color: #3b3b3b; font-size: 12px;">{{userData[0].hobby2}}</span>
                                </li>
                                <li>
                                    <span class="title">{{'profile.fav_tv' | translate}}</span>
                                    <span class="text" style="color: #3b3b3b; font-size: 12px;">{{userData[0].hobby3}}</span>
                                </li>
                                <li>
                                    <span class="title" style="color: #c5882b;">{{'profile.other_int' | translate}}</span>
                                    <span class="text" style="color: #3b3b3b; font-size: 12px;">{{userData[0].hobby4}}</span>
                                </li>
                            </ul>

                            <!-- .. end W-Personal-Info -->
                            <!-- W-Socials -->

                            <div class="widget w-socials" style="display: none;">
                                <h6 class="title">{{'profile.other_social' | translate}}</h6>
                                <a href="https://{{userData[0].facebook}}" class="social-item bg-facebook">
                                    <i class="fab fa-facebook-f" aria-hidden="true"></i> {{'profile.facebook' | translate}}
                                </a>
                                <a href="https://{{userData[0].twitter}}" class="social-item bg-twitter">
                                    <i class="fab fa-twitter" aria-hidden="true"></i> {{'profile.twitter' | translate}}
                                </a>
                            </div>


                            <!-- ... end W-Socials -->
                        </div>
                    </div>
                    <div  class="ui-block" style="padding:10px">
                        <div class="ui-block-title"  style="background-color: #272626; color: #fff;">
                            <h6 class="title" style="color: #fff;"><i class="fad fa-newspaper"></i>&nbsp;Your Posts</h6>
                        </div>
                        <div class="ui-block-content">
                        <div *ngFor="let post of posts;trackBy: trackByFn">
                            <div style="font-size: 13px; font-weight: 600; color: #50acd6;"><i class="bi bi-clock-history"></i>&nbsp;{{post.content}}</div>
                            <div class="post__date">
                                <time class="published" datetime="2017-03-24T18:18" style="font-size: 12px;">
                                    {{post.created_at | date:'medium'}} 
                                </time>
                            </div>
                            <hr>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
        <!-- ... end Left Sidebar -->


        <!-- Right Sidebar -->
        <div class="col col-xl-4 order-xl-3 col-lg-6 order-lg-3 col-md-6 col-sm-6 col-12">
            <div class="crumina-sticky-sidebar">
                <div class="sidebar__inner">
                    <div class="ui-block" >
                        <div class="date-and-place" style="padding: 10px; font-size: 25px; background-color: #af6016; color: #d4d4d4;  border: 3px solid #fff;">
                            <h4 class="date1" style="color: #fff;"><i class="bi bi-calendar3"></i>&nbsp;{{today | date: 'fullDate'}}</h4>
                        </div>
                    </div>
                    <div class="ui-block"  style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                        <div class="ui-block-title"  style="background-color: #272626; color: #fff;">
                            <h6 class="title" style="color: #fff;"><i class="fad fa-newspaper"></i>&nbsp;Voting </h6>
                        </div>
                        <div class="ui-block-content" style="text-align: center;">
                            <a *ngIf="language !='ar'"  routerLink="/voting" class="table" style="background-image: url('assets/img/Vote2025.png'); height: 300px; width: 300px; position: relative; left: 25px; top:-10px"></a>
                            <a *ngIf="language =='ar'"  routerLink="/voting" class="table" style="background-image: url('assets/img/Vote2025.png'); height: 300px; width: 300px; position: relative; left: -25px; top:-10px"></a>
                        </div>

                    </div>

                    <div *ngIf="friends.length >= 0" class="ui-block"  style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                        <div class="ui-block-title" style="background-color: #272626; color: #fff;">
                            <h6 class="title" style="color: #fff;"><i class="fad fa-user-friends"></i>&nbsp;{{currentUser.success.user.fullName | titlecase}} {{'profile.friends' | translate}}</h6>
                        </div>
                        <div class="ui-block-content">
                            <ul class="widget w-faved-page js-zoom-gallery">
                                <li *ngFor="let friend of friends">
                                    <a routerLink="/friend-about" [queryParams]="{'id': friend.user.id}">
                                        <img *ngIf="!friend.user.avatar" src="assets/img/author-main1.webp" alt="author"
                                            img1>
                                        <img *ngIf="friend.user.avatar" [src]="friend.user.avatar" alt="author" >
                                        <span style="color: #272626;">{{friend.user.fullName}}</span>
                                    </a>
                                </li>
                            </ul>
                            
                        </div>
                    </div>
                    <div class="ui-block" style="text-align: center; background-color: var(--backgroundpost-color); color: var(--text-color);">
                        <div class="ui-block-title" style="background-color: #272626; color: #fff;">
                            <h6 class="title" style="color: #fff;"><i class="bi bi-question-circle-fill"></i>&nbsp;{{'profile.voting_q' | translate}}</h6>
                        </div>
                        <div class="ui-block-content">
                            <div *ngFor="let item of votes" style="font-size: 20px; width: 100%;" dir="ltr">
                            <div *ngIf="item.QExpDate>  currentDate">
                                <div *ngIf="item.Qstatus == 1">
                                <form [formGroup]="FanvoteForm" (ngSubmit)="setvotfan()">
                                    <fieldset style="text-align: left;">
                                        <div style="font-size: 18px;">
                                            <Label formControlName="VoQuest" name="VoQuest" style="border-radius: 0px; width: 100%; color:  var(--text-color); border: 0px; font-weight: 600;">{{item.VoteQ}}</Label>
                                            <Label formControlName="VoteNo" name="VoteNo1" style="display: none;"> {{item.Qnumber}} </Label>
                                            <Label formControlName="Votedate" name="VoteNo1" style="display: none;">{{currentDate}}</Label>
                                        </div>
                                        
                                        <div *ngFor="let itemtotal of QAll">
                                            <label style="font-size: 15px; color: var(--text-color);"><input type="radio" id="A11" formControlName="QVA" name="QVA" [value]="item.VoteA1" />{{item.VoteA1}}&nbsp;(<span *ngFor="let item2 of QA11">
                                                <span *ngIf="item2.CFA1 == ''">0%</span>
                                                <span *ngIf="item2.CFA1 != ''">{{(item2.CFA1 /itemtotal.CFAll * 100).toFixed(2)}}%</span>
                                            </span>)</label>
                                            <div class="meter"><span *ngFor="let item1 of QA11" [style.width.%] ="item1.CFA1 /itemtotal.CFAll * 100"></span></div>
                                        </div>
                                    
                                        <div *ngFor="let itemtotal of QAll">
                                            <label style="font-size: 15px; color:  var(--text-color);"><input type="radio" id="A22" formControlName="QVA" name="QVA" [value]="item.VoteA2" />{{item.VoteA2}}&nbsp;(<span *ngFor="let item3 of QA12">
                                                <span *ngIf="item3.CFA2 == ''">0%</span>
                                                <span *ngIf="item3.CFA2 != ''">{{(item3.CFA2 /itemtotal.CFAll * 100).toFixed(2)}}%</span>
                                            </span>)</label>
                                            <div class="meter"><span *ngFor="let item3 of QA12" [style.width.%] ="item3.CFA2 /itemtotal.CFAll * 100"></span></div>
                                        </div>
                                        <div *ngFor="let itemtotal of QAll">
                                            <div *ngIf="item.VoteA3 != ''">
                                            <label style="font-size: 15px; color:  var(--text-color);"><input type="radio" id="A33" formControlName="QVA" name="QVA" [value]="item.VoteA3" />{{item.VoteA3}}&nbsp;(<span *ngFor="let item4 of QA13">
                                                <span *ngIf="item4.CFA3 == ''">0%</span>
                                                <span *ngIf="item4.CFA3 != ''">{{(item4.CFA3 /itemtotal.CFAll * 100).toFixed(2)}}%</span>
                                            </span>)</label>
                                            <div class="meter"><span *ngFor="let item4 of QA13" [style.width.%] ="item4.CFA3 /itemtotal.CFAll * 100"></span></div>
                                        </div></div>
                                    </fieldset>
                                    <br>
                                    <p *ngFor="let itemtotal of QAll" style="text-align: left; font-size: 12px; color: var(--text-color)">Count of votes : {{itemtotal.CFAll}}</p>
                                    <div>
                                        <button formControlName="btnvote" class="btn btn-danger" type="submit" name="" style="background-color: #c4492a; border-radius: 10px; font-size: 18px;"><i class="bi bi-hand-index-thumb-fill"></i> &nbsp;Vote</button>
                                    </div>
                                    <p style="font-size: 12px; color: var(--text-color)">Vote finish tell {{item.QExpDate}}</p>
                                </form>
                            </div></div></div>
                            
                        </div>
                    </div>
                    <div class="ui-block"  style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                        <div class="ui-block-title"  style="background-color: #272626; color: #fff;">
                            <h6 class="title" style="color:#fff;"><i class="fad fa-smog"></i>&nbsp;Weather</h6>
                        </div>
                        <div class='wrapper' style="text-align: left;">
                            <div class='panel' style="text-align: left;">
                              <h4 class='city' id='city' style="color: var(--text-color);"></h4>
                              <div class='weather' id='weather'>
                                <div class='group secondary'>
                                  <h5 id='dt' style="color: var(--text-color);"></h5>
                                  <h5 id='description' style="color: var(--text-color);"></h5>
                                </div>
                                <div class='group secondary'>
                                  <h5 id='wind' style="color: var(--text-color);"></h5>
                                  <h5 id='humidity' style="color: var(--text-color);"></h5>
                                </div>
                                <div class='temperature' id='temperature'>
                                  <h3 class='temp' id='temp' style="color: var(--text-color);"><i id='condition'></i> <span id='num'></span><a class='fahrenheit active' id='fahrenheit' href="#" style="color: var(--text-color);">&deg;F</a><span class='divider secondary'>|</span><a class='celsius' id='celsius' href="#">&deg;C</a></h3>
                                </div>
                                <br>
                              </div>
                            </div>
                    </div>
                </div>
                </div>
            </div>
        </div>

        <!-- ... end Right Sidebar -->

    </div>
</div>
<!-- [config]="{backdrop: 'static'}" -->
<!-- Delete Modal -->
<div class="modal fade" bsModal #postDeleteModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true" [dir]="direction">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel" style="color: var(--text-color);">{{'profile.delete_post' | translate}}</h5>
                <button type="button" class="close" (click)="postDeleteModal.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <label style="color: var(--text-color);">{{'profile.sure_delete' | translate}}</label>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="postDeleteModal.hide()">{{'profile.no' | translate}}</button>
                <button type="button" class="btn btn-danger" (click)="deletePost(postDeleteModal)">{{'profile.yes' | translate}}</button>
            </div>
        </div>
    </div>
</div>
<!-- Delete Modal -->

<!-- Delete Modal comment -->
<div class="modal fade" bsModal #commentDeleteModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1"
    role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" [dir]="direction">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel" style="color: var(--text-color);">{{'profile.delete_comment' | translate}}</h5>
                <button type="button" class="close" (click)="commentDeleteModal.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <label style="color: var(--text-color);">{{'profile.sre_comment' | translate}}</label>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="commentDeleteModal.hide()">{{'profile.no' | translate}}</button>
                <button type="button" class="btn btn-danger"
                    (click)="deleteComment(commentDeleteModal,selectPostId)">{{'profile.yes' | translate}}</button>
            </div>
        </div>
    </div>
</div>
<!-- Delete Modal Comemnt -->

<!-- Edit Post  Modal -->

<div class="modal fade" bsModal #postEditModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true" [dir]="direction">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel" style="color: var(--text-color);">{{'profile.edit_post' | translate}}</h5>
                <button type="button" class="close" (click)="closeEditModal(postEditModal)">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form #postEditForm="ngForm">
                    <div class="form-group">
                        <label style="padding-right: 290px;" for="projectDescription">
                            <b style="color: var(--text-color);">{{'profile.descrip_post' | translate}}</b>
                        </label>
                        <textarea class="form-control" name="content" #content="ngModel"
                            [(ngModel)]="selectPost.content" rows="2" required autocomplete="off" style="background-color: var(--background-color); color: var(--text-color);"></textarea>
                    </div>
                    <div *ngIf="selectPost.image" class="form-group">
                        <label for="image">
                            <b style="color: var(--text-color);">{{'profile.image' | translate}}</b>
                        </label>
                        <img [src]="selectPost.image" alt="Photo"  style="width: 100%; height: 400px; border:0px solid #fff; border-radius: 0px; object-fit: cover;">
                        <input type="file" class="form-control" name="image" #image="ngModel"
                            [(ngModel)]="selectPost.image" (change)="onImageSelect($event)"  style="width: 100%; height: 100px; border:0px solid #fff; border-radius: 0px;">

                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeEditModal(postEditModal)">{{'profile.close' | translate}}</button>
                <button type="button" class="btn btn-primary" (click)="updatePost(postEditModal)"
                    [disabled]="!postEditForm.form.valid">{{'profile.save_change' | translate}}</button>
            </div>
        </div>
    </div>
</div>

<!-- Edit Post  Modal -->

<!-- Window-popup Update Header Photo -->

<div class="modal fade" id="update-header-photo" tabindex="-1" role="dialog" aria-labelledby="update-header-photo"
    aria-hidden="true" [dir]="direction">
    <div class="modal-dialog window-popup update-header-photo" role="document">
        <div class="modal-content">
            <a routerLink="/profile" class="close icon-close" data-dismiss="modal" aria-label="Close">
                <svg class="olymp-close-icon">
                    <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-close-icon"></use>
                </svg>
            </a>

            <div class="modal-header">
                <h6 class="title">{{'profile.cover_update' | translate}}</h6>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="post-photo" tabindex="-1" role="dialog" aria-labelledby="update-header-photo"
    aria-hidden="true" [dir]="direction">
    <div class="modal-dialog window-popup update-header-photo" role="document">
        <div class="modal-content">
            <a routerLink="/profile" class="close icon-close" data-dismiss="modal" aria-label="Close">
                <svg class="olymp-close-icon">
                    <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-close-icon"></use>
                </svg>
            </a>

            <div class="modal-header">
                <h6 class="title">{{'profile.post_photo' | translate}}</h6>
            </div>

            <div class="modal-body">
                <a class="upload-photo-item">
                    <svg class="olymp-computer-icon">
                        <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-computer-icon"></use>
                    </svg>

                    <h6>{{'profile.up_photo' | translate}}</h6>
                    <span>{{'profile.browse_comp' | translate}}</span>
                    <form>
                        <input type="file" class="form-control" formcontrolName="avatar" name="avatar">
                    </form>
                </a>

                <a routerLink="/profile" class="upload-photo-item" data-toggle="modal"
                    data-target="#choose-from-my-photo">

                    <svg class="olymp-photos-icon">
                        <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-photos-icon"></use>
                    </svg>

                    <h6>{{'profile.choose_photo' | translate}}</h6>
                    <span>{{'profile.choose_up' | translate}}</span>
                </a>
            </div>
        </div>
    </div>
</div>
